module.exports = __webpack_public_path__ + "img/img-95b299.png";